export default function SellerHeader({ user }) {
  return (
    <section className="section-seller">
      <div className="container">
        <div className="title">
          <h3>My Selling Product</h3>
        </div>
        <div className="card">
          <div className="d-flex justify-content-start align-items-center">
            <img className="image-user" src={user.image} alt="" />
            <div className="me-auto">
              <h4>{user.name}</h4>
              <p>{user.city && user.city}</p>
            </div>
            <div className="mx-auto text-center">
              <h4>Total Penjualan</h4>
              <p>10.000</p>
            </div>
            <p className="color-red ms-auto ">Please update profile!</p>
          </div>
        </div>
      </div>
    </section>
  );
}
